import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getCaseCardsConfiguration } from '@/common/services/UsersService'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { type GroupOptionsBase, SERVER_DATA_SCOPE, SERVER_DATA_TYPE } from '@/common/types/cacheConstants'

function groupOptions(config: GroupOptionsBase = {}) {
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.CASE_LAYOUT,
      type: SERVER_DATA_TYPE.ITEM,
    }),
    staleTime: Infinity,
    queryFn: getCaseCardsConfiguration,
  }
  return queryOptions(merge(defaultConfig, config))
}

async function fetch(options: GroupOptionsBase = {}) {
  return queryClient.fetchQuery(groupOptions(options))
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.CASE_LAYOUT,
      type: SERVER_DATA_TYPE.ITEM,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
